//====== FONT SIZES ======//
export const heading_1 = "40px";
export const heading_2 = "32px";
export const heading_3 = "24px";
export const heading_4 = "16px";
export const heading_5 = "12px";

export const body_hero = "20px";
export const body_1 = "16px";
export const body_2 = "12px";

export const button_text = "16px";
